import Role from './role/state';
import Permission from './permission/state';

export default {
  namespaced: true,
  modules: {
    Role,
    Permission,
  },
};
